export default __webpack_public_path__ + "static/media/11t.8f02bf88.jpg";